import { render, staticRenderFns } from "./InsideProductProduct.vue?vue&type=template&id=8b8acb20&scoped=true"
import script from "./InsideProductProduct.vue?vue&type=script&lang=js"
export * from "./InsideProductProduct.vue?vue&type=script&lang=js"
import style0 from "./InsideProductProduct.vue?vue&type=style&index=0&id=8b8acb20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8acb20",
  null
  
)

export default component.exports